import React from "react";

const VideoPlayer = ({ videoUrl, topic, id }) => {

  return (
    <div>

      <video
        controls
        controlsList="nodownload" 
        style={{ width: "100%", maxWidth: "800px", display: "block", margin: "auto", borderRadius: "10px" }}
        onContextMenu={(e) => e.preventDefault()}
      >
        <source src={videoUrl+'/'+id} type="video/mp4" />
        {/* <source src="./video2.mp4"/> */}
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoPlayer;
